import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { stat } from 'fs';
import {
  Doc,
  ProcessRunStatusEnum,
  ProcessRunStatusResult,
} from '../../models/common';
import { ProgressTimeService } from '@shared/services/progress-time.service';
import { Config } from 'src/app/config';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'process-run-status',
    templateUrl: './process-run-status.component.html',
    styleUrls: ['./process-run-status.component.scss'],
    standalone: false
})
export class ProcessRunStatusComponent implements OnInit, OnChanges {
  @Output() onClose = new EventEmitter();
  @Input() doc: Doc;
  @Input() status: ProcessRunStatusResult;

  completedPct: number = undefined;
  displayCompletedPct: number = 0;
  time: string;
  showProgressBarAndTimeLeft: boolean = Config.assetConfigData['showEstimatedTimeLeftDuringDocProcessing'];

  constructor(private progressTimeService: ProgressTimeService, private translateService: TranslateService) {
    
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes['status']) {

      let percStatus: ProcessRunStatusResult = changes['status'].currentValue;

      if (this.completedPct == undefined || this.completedPct < percStatus.completedPct) {
        this.completedPct = percStatus.completedPct;
        this.displayCompletedPct = Math.round(this.completedPct);
      }
      if (percStatus.estimatedTime != null && this.showProgressBarAndTimeLeft) {
          const timeValue = percStatus.remainingTime ? percStatus.remainingTime : percStatus.estimatedTime;
          this.time = this.progressTimeService.getTimeInMinutes(timeValue);
          this.doc['remainingProcessingTime'] =  this.formatTime(this.time);
      }
    }
  }
  formatTime(time: string): string {
    const timeParts = time.split(':');
    let minutes = parseInt(timeParts[0]);
    let seconds = parseInt(timeParts[1]);
    let result = '';
    
    if (minutes > 0) {
      let minutesLabel = this.translateService.instant('translate.general.minutes');
      result += minutes + ' ' + minutesLabel + ' ';
    }
    if (seconds > 0) {
      let secondsLabel = this.translateService.instant('translate.general.seconds');
      result += seconds + ' ' + secondsLabel;
    }
    return result.trim();
  }


  ngOnInit(): void {}

  close() {
    this.onClose.emit();
  }
}
